import { ReactNode } from 'react';
import { Compass } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import SprakVelger from './SprakVelger';

/** Felles ramme for alle sidene: merket og språkvelgeren øverst, og innholdet i en bred, rolig flate. */
export default function Ramme({ children }: { children: ReactNode }) {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col bg-flate">
      <header className="sticky top-0 z-20 border-b border-slate-200/80 bg-white/90 backdrop-blur supports-[backdrop-filter]:bg-white/75">
        <div className="mx-auto flex h-16 max-w-6xl items-center justify-between px-6 lg:px-10">
          <span className="flex items-center gap-3">
            <span aria-hidden="true" className="flex h-8 w-8 items-center justify-center rounded-lg bg-slate-900 text-white">
              <Compass className="h-[1.125rem] w-[1.125rem]" strokeWidth={2} />
            </span>
            <span className="font-display text-[15px] font-semibold tracking-tight text-slate-900">{t('app.navn')}</span>
          </span>
          <SprakVelger />
        </div>
      </header>
      <main className="mx-auto w-full max-w-6xl flex-1 px-6 py-10 lg:px-10">{children}</main>
    </div>
  );
}
